export const servicesSupportedByUrl = [
  'wms',
  'wfs',
  'wmts',
  'kml',
  'gpx',
  'geojson',
  'arcgis',
  'geosparql',
] as const;
